// This file was auto-generated by Fern from our API Definition.
export const QueryWorkflowRevisionsRequestOrder = {
    Ascending: "ascending",
    Descending: "descending",
};
